exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth{\n    width: 180px;\n}\n.swal2-popup .swal2-input{\n  line-height: 40px;\n}\n.swal2-popup .swal2-textarea{\n  height: 85px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72523b02","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard/Views/Tags/TagDetails.vue
// module id = 67gd
// module chunks = 0